import type { EsProduct } from '~/types/elastic'

export function useOfferFormDialog() {
  const { dialog, open, close: closeDialog } = useUiDialog('offer-form-dialog')
  const product = useState('offerFormDialogProduct', () => null as null | EsProduct)

  const openFor = (productData: EsProduct) => {
    product.value = productData
    open()
  }

  const close = () => {
    closeDialog()
    product.value = null
  }

  return {
    ...dialog,
    product,
    openFor,
    close,
  }
}
